import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'

const formatDate = (value) => {
  if (!value) return '-'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return '-'
  return parsed.toLocaleString()
}

const VersionsModal = ({
  show,
  onHide,
  site,
  versions = [],
  activeVersionId,
  loading,
  rollbackProcessing,
  selectedVersionId,
  onSelectVersion,
  onRollback
}) => {
  const selectedVersion = versions.find((version) => version.id === selectedVersionId)
  const orderedVersions = [...versions].sort((a, b) => {
    if (!!a.isActive !== !!b.isActive) {
      return a.isActive ? -1 : 1
    }
    return new Date(b.createdAt) - new Date(a.createdAt)
  })

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Versions {site?.subdomain ? `- ${site.subdomain}` : ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" className="me-2" />
            Loading versions...
          </div>
        ) : versions.length === 0 ? (
          <div className="text-muted">No versions are available yet.</div>
        ) : (
          <div className="list-group">
            {orderedVersions.map((version) => {
              const checked = selectedVersionId === version.id
              const active = activeVersionId === version.id || version.isActive

              return (
                <label key={version.id} className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="me-3">
                    <input
                      type="radio"
                      name="site-version"
                      className="form-check-input me-2"
                      checked={checked}
                      onChange={() => onSelectVersion(version.id)}
                    />
                    <span className="fw-semibold">{version.label || version.id}</span>
                    {active ? <span className="badge bg-success ms-2">Active</span> : null}
                    <div className="text-muted small mt-1">Created: {formatDate(version.createdAt)}</div>
                  </div>
                </label>
              )
            })}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-secondary" onClick={onHide} disabled={rollbackProcessing}>
          Close
        </button>
        <button
          className="btn bg-blue-electric text-white"
          onClick={onRollback}
          disabled={loading || rollbackProcessing || !selectedVersion || selectedVersion.id === activeVersionId}
        >
          {rollbackProcessing ? 'Rolling back...' : 'Rollback to selected version'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default VersionsModal
